import React, { Fragment, useEffect, useState } from "react";
import QuestionHeading from "./QuestionHeading";
import { RIconDocument } from "../../../components/Icons";
import { Card, Row } from "react-bootstrap";
import { FormField, FormFieldCheck } from "../../../components/Form/FormField";
const OPTIONS = [{ label: "Nil / NA", value: "Nil" }];

const Q_09 = ({
  dayQuestions,
  register,
  watch,
  setValue,
  reportError,
  trigger,
  isSubmitted,
}) => {
  const [bgClass, setBgClass] = useState("");
  const Q1 = dayQuestions.find((item) => item.id === 52);
  const selectedAns = watch(`questions_${Q1.id}`);
  const selectedCheck1 = watch(`ans_${Q1.id}`);
  useEffect(() => {
    if (selectedAns === "Nil") {
      setValue(`questions_${Q1.id}`, "");
    }
    if (selectedCheck1 === "Nil") {
      setValue(`questions_${Q1.id}`, "Nil");
      trigger(`questions_${Q1.id}`);
    }
    if (selectedAns) {
      setBgClass("success");
    } else {
      setBgClass("");
    }
  }, [selectedAns, selectedCheck1]);
  const allowOnlyNumbers = (event) => {
    const input = event.target;
    // Remove any non-numeric characters
    input.value = input.value.replace(/[^0-9]/g, "");
  };
  return (
    <Fragment>
      <Card.Body className={`question-heading px-3 bg-${bgClass}-lt text-dark`}>
        <QuestionHeading
          icon={<RIconDocument className={`text-primary text-${bgClass}`} />}
          number="09"
          title={Q1.subcat}
        />
      </Card.Body>
      <Card.Body className="px-3">
        <Row>
          <FormFieldCheck
            isLabel={false}
            name={`ans_${Q1.id}`}
            register={register}
            options={OPTIONS}
            type="checkbox"
            size="12"
            disabled={isSubmitted}
          />
          <FormField
            label={"Nos. of Proforma-3A"}
            name={`questions_${Q1.id}`}
            register={register}
            size="12"
            className={`mb-2 ${selectedCheck1 ? "text-transparent" : ""}`}
            disabled={isSubmitted || selectedCheck1}
            error={reportError?.[`questions_${Q1.id}`]}
            onInput={allowOnlyNumbers}
            placeholder="Numbers only"
          />
        </Row>
      </Card.Body>
    </Fragment>
  );
};

export default Q_09;
